import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { FormFieldComponentProps } from '@sheerid/jslib';
import { ClassGroupChoice } from '../../../lib/types/types';
import { ClassGroupsEnum } from '../../../lib/types/runtimeTypes';
import { SelectComponent } from '../../FormInputs/Select/SelectComponent';

interface ClassGroupOptionsProps {
    onChange: (value: ClassGroupChoice) => void;
    inputId: string;
    fieldId: string;
}

export const ClassGroup = ({
    value,
    onChange,
    intl,
    placeholder,
    isErrored,
    inputId,
    fieldId,
}: ClassGroupOptionsProps & InjectedIntlProps & FormFieldComponentProps) => {
    const getClassGroupOptions = () => {
        const options: ClassGroupChoice[] = [];

        Object.values(ClassGroupsEnum).map(classGroup => options.push({
            value: classGroup,
            label: intl.formatMessage({ id: `classGroupOptions.${classGroup}`, defaultMessage: `${classGroup}` }),
        }));
        return options;
    };

    const classGroupOptions: ClassGroupChoice[] = getClassGroupOptions();

    return (
        <div className="sid-class-group sid-field">
            <div className="sid-l-space-top-sm" />
            <SelectComponent
                fieldId={fieldId}
                inputId={inputId}
                value={value}
                options={classGroupOptions}
                onChange={onChange}
                placeholder={placeholder}
                isErrored={isErrored}
            />
        </div>
    );
};

export const ClassGroupComponent = injectIntl(ClassGroup);
